module.exports = __webpack_public_path__ + "img/image_slide1_2.45d44a6a.jpeg";